import React, { useEffect, useState } from "react";
import styled from "styled-components";

// Components
import SubMenuTemplate from "new_components/templates/SubMenuTemplate";
import Text from "new_components/atoms/Text";
import SectionHeader from "./SectionHeader";

// Constants
import colors from "styles/colors";
import typography from "styles/typography";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";
import Icon from "new_components/atoms/Icon";

const ResponsesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: -40px;
`;

const ResponseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 40px;
  border-bottom: 1px solid ${colors.neutral[200]};
`;

const QuestionWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

const OptionsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 8px;
`;

const OptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  padding-left: 16px;
  width: 100%;
`;

const Checkmark = styled.div`
  color: ${colors.secondary[500]};
  display: flex;
  align-items: center;
  right: 0;
`;

const SelectedOption = styled(Text)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${colors.secondary[500]};
  font-size: 14px;
  font-weight: 600;
  background-color: ${colors.secondary[50]};
  padding: 4px 8px;
  border-radius: 4px;
  width: 100%;
`;

const FollowupSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 10px;
  background-color: ${colors.neutral[200]};
  border-radius: 8px;
`;

const ResponseContainer = styled.div`
  margin-top: 10px;
`;

const removeFeedback = (question) => {
  return question.replace(/\*\*Feedback:\*\*.*$/, "").trim();
};

const IndividualResponse = ({ responses, participantName, questions }) => {
  const questionResponses = responses?.task_list;
  return (
    <ResponsesWrapper>
      <Text typographyStyle={typography.subhead.semibold}>
        {participantName}
      </Text>
      {questionResponses.map((response, index) => {
        const question = questions[index];
        const isScale = question?.type === "scale";
        const isSingleOrMulti = question?.type === "single" || question?.type === "multi";
        const scaleValue = isScale
          ? question?.scale === "0-5" || question?.scale === "1-5"
            ? 5
            : 10
          : null;

        let selectedOptions = [];
        if (isSingleOrMulti) {
          try {
            selectedOptions = question.type === "multi"
              ? JSON.parse(response?.response || "[]")
              : [response?.response];
          } catch (e) {
            console.error('Error parsing response:', e);
          }
        }

        return (
          <ResponseWrapper key={index}>
            <QuestionWrapper>
              <Text typographyStyle={typography.smallText.semibold}>
                {response?.question}
              </Text>
            </QuestionWrapper>

            {isSingleOrMulti ? (
              <OptionsList>
                {question.options.map((option, optionIndex) => {
                  const isSelected = selectedOptions.includes(option);
                  return (
                    <OptionItem key={optionIndex}>
                      {isSelected ? (
                        <SelectedOption typographyStyle={typography.caption.regular}>
                          {option}
                          {isSelected && (
                        <Checkmark>
                          <Icon size={16} color={colors.secondary[500]} name={ICON_SET.checkMark} />
                        </Checkmark>
                          )}
                        </SelectedOption>
                      ) : (
                          <Text style={{
                            padding: "4px 8px",
                            borderRadius: "4px",
                          }} typographyStyle={typography.caption.regular}>
                          {option}
                        </Text>
                      )}
                    </OptionItem>
                  );
                })}
              </OptionsList>
            ) : (
                <Text typographyStyle={typography.body.regular}>
                  {response?.response} {isScale ? "/" + scaleValue : null}
                </Text>
            )}

            {response?.follow_up && (
              <FollowupSection key={index}>
                <Text
                  typographyStyle={typography.caption.semibold}
                  color={colors.primary[500]}
                >
                  AI Follow up
                </Text>
                <Text typographyStyle={typography.caption.semibold}>
                  {removeFeedback(response?.follow_up?.question)}
                </Text>
                <ResponseContainer>
                  <Text typographyStyle={typography.caption.regular}>
                    {response?.follow_up?.response}
                  </Text>
                </ResponseContainer>
              </FollowupSection>
            )}
          </ResponseWrapper>
        );
      })}
    </ResponsesWrapper>
  );
};

const IndividualView = ({ responses, clearUser, selectedParticipant, questions, filters }) => {
  const [selectedUser, setSelectedUser] = useState();

  const handleUserSelect = (user) => {
    clearUser();
    setSelectedUser(user.id);
  };
  useEffect(() => {
    if (selectedParticipant) {
      setSelectedUser(selectedParticipant?.employee_id);
    }
    clearUser();
  }, [selectedParticipant]);

  const menuItems = responses.map((participant, index) => {
    return {
      id: participant.employee,
      categoryTitle: participant.employee_full_name,
      categoryContent: (
        <IndividualResponse
          responses={participant.task_response}
          participantName={participant.employee_full_name}
          questions={questions}
        />
      ),
    };
  });

  return (
    <SubMenuTemplate
      onItemSelect={handleUserSelect}
      menuItems={menuItems}
      selected={selectedUser}
      type="single"
      actionRow={<SectionHeader filters={filters} icon={ICON_SET.assign} text="Individuals" />}
      searchable
    />
  );
};

export default IndividualView;
